import * as z from 'zod'

import { idNoUnderscoreSchema, nonEmptyTrimmedStringSchema } from './primitives'
import topicSchema from './topic'

const surveySchema = z.strictObject({
  id: idNoUnderscoreSchema,
  title: nonEmptyTrimmedStringSchema,
  icon: nonEmptyTrimmedStringSchema,
  subtitle: z.string().nullish(),
  description: z.string().nullish(),
  topics: z.array(topicSchema),
})

export type Survey = z.output<typeof surveySchema>

export default surveySchema
